import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="max-w-xl">
      <h1 className="font-display text-3xl font-semibold text-white">No such record</h1>
      <p className="mt-4 text-base text-void-400">
        That page is not part of the personnel archive.
      </p>
      <Link
        to="/"
        className="mt-8 inline-block text-sm font-medium text-leviathan-500 transition-colors hover:text-leviathan-600"
      >
        ← Back to the archive
      </Link>
    </div>
  );
}
